import Icon from 'components/icons/Icon';
import React from 'react';
import styled from 'styled-components/native';

const BadgeContainer = styled.View<{ backgroundColor?: string }>`
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  border-radius: 45px;
  background-color: ${(p) => p.backgroundColor || p.theme.colors.gray50};
`;

const IconWrapper = styled.View<{ isAimoPlus?: boolean }>`
  margin-left: ${(p) => (p.isAimoPlus ? '3px' : '0')};
  margin-top: ${(p) => (p.isAimoPlus ? '-1px' : '0')};
`;

const IconBadge: React.FC<{ name: string; backgroundColor?: string }> = ({
  name,
  backgroundColor,
}) => {
  const isAimoPlus = name === 'Aimo-Plus';

  return (
    <BadgeContainer
      backgroundColor={backgroundColor}
      testID={`icon-badge-${name}`}>
      <IconWrapper isAimoPlus={isAimoPlus}>
        <Icon name={name} />
      </IconWrapper>
    </BadgeContainer>
  );
};

export default IconBadge;
